import angular from 'angular';

//import 'bootstrap/dist/js/bootstrap.js';
//import 'bootstrap/dist/css/bootstrap.css';
import 'angular-material/angular-material.css';
import './app.css';

import Home from './home/home.module';
import Core from './core/core.module';
import Login from './login/login.module';
import Authenticate from './authenticate/authenticate.module';
import Results from './results/results.module';
import Accept from './accept/accept.module';

angular.module('app', [Core, Accept, Home, Login, Authenticate, Results]);




// WEBPACK FOOTER //
// ./src/client/app/app.module.js